import React from 'react';
import { pushDataLayerEvent } from './TrackingScripts';

export const PHONES = {
  gino: { name: 'Gino', display: '0471 46 41 88', tel: '+32471464188' },
  bjorn: { name: 'Bjorn', display: '0477 60 68 33', tel: '+32477606833' },
};

// Clickable tel: link that fires the "telefoon_klik" dataLayer event
const PhoneLink = ({ phone, locatie, className = '', children }) => (
  <a
    href={`tel:${phone.tel}`}
    onClick={() => pushDataLayerEvent('telefoon_klik', { telefoon: phone.tel, persoon: phone.name, locatie })}
    className={className}
    data-testid={`phone-link-${locatie}-${phone.name.toLowerCase()}`}
  >
    {children || phone.display}
  </a>
);

export default PhoneLink;
